import { createMarkup } from "../../helpers";

const Table3 = ({ details }) => {
	return (
		<table className="approved assigned">
			<thead>
				<tr>
					<th colSpan="2" className="hdg">
						Guest Information
					</th>
				</tr>
			</thead>
			{details.values[0].value ? (
				<tbody>
					{details.values.map((item, index) => {
						return (
							<tr key={index}>
								<th className="right top" style={{ width: "25%" }}>
									{item.key}
								</th>
								<td
									className="left"
									dangerouslySetInnerHTML={createMarkup(item.value)}
								/>
							</tr>
						);
					})}
					{details.invite.golf.status === 1 &&
						details.invite.valuesGolf.map((item, index) => {
							return (
								<tr key={index}>
									<th className="right top">{item.key}</th>
									<td
										className="left"
										dangerouslySetInnerHTML={createMarkup(item.value)}
									/>
								</tr>
							);
						})}
					{details.invite.gift.status === 1 &&
						details.invite.valuesGift.map((item, index) => {
							return (
								<tr key={index}>
									<th className="right top">{item.key}</th>
									<td
										className="left"
										dangerouslySetInnerHTML={createMarkup(item.value)}
									/>
								</tr>
							);
						})}
				</tbody>
			) : (
				<tbody>
					<tr>
						<td
							className="center"
							colSpan="2"
							style={{ paddingTop: "15px", paddingBottom: "15px" }}
						>
							<span className="working">-- Details not yet submitted --</span>
						</td>
					</tr>
				</tbody>
			)}
		</table>
	);
};

export default Table3;
